import { render, staticRenderFns } from "./WidgetPlannedArticles.vue?vue&type=template&id=47591825&scoped=true"
import script from "./WidgetPlannedArticles.vue?vue&type=script&lang=js"
export * from "./WidgetPlannedArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47591825",
  null
  
)

export default component.exports